import { View, Text, TextInput, Pressable, ScrollView } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import { useNavigation } from '@react-navigation/native'
import AsyncStorage from '@react-native-async-storage/async-storage';
import alert from './../alert'
import nameSurname from '../namesSurnames';
import GlobalStyles from './../style';
import playerEmptyObject from './../playerEmptyObject'
import uuid from 'react-native-uuid';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'
import allStats from "./../allStats"
import allStatsForGame from '../allStatsForGame';

let lang = undefined;

const NewGame = () => {
    const navigation = useNavigation();
    const [name, onChangeName] = React.useState("");
    const [teamName, onChangeTeamName] = React.useState("");

    useLayoutEffect(() => {
      navigation.setOptions({
          headerTitle: transl('MainMenu.nuevaPartida',lang)
      })
    }, []);

    //receivedData
    const [value, setvalue] = useState('');
    const readValue = () => {
      AsyncStorage.getItem('equipos')
      .then((value)=> {
        setvalue(value)
      })
    }
    readValue()

    const language = useSelector((state) => state.language);
    lang = dr.idiomas[language ? language : 0].value

  return (
    <View style={{ marginHorizontal: 10, marginBottom: 'auto', marginTop: 'auto' }}>
      <ScrollView>
        <Text style={{ textAlign: 'center' }}>{transl('NewGame.tuNombre',lang)}</Text>
        <TextInput
          style={GlobalStyles.input}
          onChangeText={onChangeName}
          value={name}
        />
        <Text style={{ textAlign: 'center' }}>{transl('NewGame.nombreDeTuEquipo',lang)}</Text>
        <TextInput
          style={GlobalStyles.input}
          onChangeText={onChangeTeamName}
          value={teamName}
        />
        <Text style={{ color: '#e60000' }}>{transl('NewGame.estasSeguro',lang)}</Text>
        <View style={{ margin: 25, marginLeft: 'auto', marginRight: 'auto' }}>
          <Pressable
            style={GlobalStyles.buttonDelete}
            onPress={() => {
              alert(transl('General.warning',lang), transl('NewGame.siCreas',lang), [
                {text: transl('General.cancelar',lang),onPress: () => void(0),style: "cancel"},
                {
                  text: "OK", onPress: () => {
                    if (generateNewGame(name, teamName).isCorrect) {
                      navigation.navigate('MainMenu')
                      navigation.navigate('HomeScreen')
                      alert(transl('NewGame.bienvenido',lang), transl('NewGame.siNoSabes',lang), [
                        { text: transl('General.OK',lang), onPress: () => void (0) }
                      ])
                    } else {
                      alert("ERROR", "Los campos no pueden estar vacios", [
                        { text: transl('General.OK',lang), onPress: () => void (0) }
                      ])
                    }
                  }
                }
              ])
            }
            }
          >
            <Text style={GlobalStyles.textForButtonMain}>{transl('MainMenu.nuevaPartida',lang)}</Text>
          </Pressable>
        </View>
        <View>
          <Text style={{ marginBottom: 20, marginTop: 50 }}>{transl('NewGame.siEstasTeniendo',lang)}</Text>
          <View style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            <Pressable
              style={GlobalStyles.buttonMigrate}
              onPress={() => {
                alert(transl('General.warning',lang), transl('NewGame.siActualizas',lang), [
                  {text: transl('General.cancelar',lang),onPress: () => void (0),style: "cancel"},
                  {text: transl('General.OK',lang), onPress: () => {updateData(value)}}
                ])
              }
              }>
              <Text style={GlobalStyles.textForButtonMain}>{transl('NewGame.actualizacion',lang)}</Text>
            </Pressable>
          </View>
        </View>
      </ScrollView>
    </View>
  )

  function updateData(oldJson){
    if(oldJson === undefined || !oldJson) {
      alert(transl('General.error',lang),transl('NewGame.noPuedesMigrar',lang),[
        {text: transl('General.OK',lang), onPress: () => void(0), style: "cancel"}
      ])
      return
    }
    oldJson = oldJson != null ? JSON.parse(oldJson) : null

    let newData = generateNewGame(oldJson.profile.managerName,oldJson.teams[0].name,true).data

    if(oldJson.profile.uuid != undefined) newData.profile.uuid = oldJson.profile.uuid
    if(oldJson.others.trophies != undefined) newData.others.trophies = oldJson.others.trophies
    if(oldJson.multiplayer != undefined) newData.multiplayer = oldJson.multiplayer;
    if(oldJson.others.vecesTodosLosPartidosHechos != undefined && oldJson.others.vecesTodosLosPartidosHechos%2) newData.others.vecesTodosLosPartidosHechos = oldJson.others.vecesTodosLosPartidosHechos
    newData.profile.money = oldJson.profile.money
    newData.teams[0].players.length = oldJson.teams[0].players.length
    for(let i = 0; i < oldJson.teams[0].players.length; i++){
      const name = oldJson.teams[0].players[i].name
      const skills = oldJson.teams[0].players[i].skills
      const broom = oldJson.teams[0].players[i].broom
      let age = 25
      if(oldJson.teams[0].players[i].age != undefined){
        age = oldJson.teams[0].players[i].age
      }
      if(newData.teams[0].players[i] == undefined) newData.teams[0].players[i] = playerEmptyObject()
      newData.teams[0].players[i].name = name
      newData.teams[0].players[i].skills = skills
      newData.teams[0].players[i].broom = broom
      newData.teams[0].players[i].age = age
    }

    const storeData = async (data) => {
      try {
        const jsonValue = JSON.stringify(data)
        await AsyncStorage.setItem('equipos', jsonValue)
      } catch (e) {
        console.log("error saving file")
        console.log(e)
      }
    }
    storeData(newData);

    alert(transl('NewGame.actualizacionCorrecta',lang),transl('NewGame.tusDatosAntiguos',lang),[
      {
        text: transl('General.OK',lang),
        onPress: () => {navigation.navigate('MainMenu'),navigation.navigate('HomeScreen')},
        style: "cancel"
      }
    ])
  }
}

function generateNewGame(name,teamName,bypass = false) {
  //como es nueva partida, vamos a generar y guardar nuevos datos
  //diccionario de skills: precision, reflejos, manejo, fuerza, resistencia, ataque (visión), defensa (comunicación); escoba: velocidad, maniobra, estabilidad; escondidas: agresividad, confianza

  if (!bypass && (name == "" || teamName == "")) {
    return {isCorrect:false,data:{}};
  }

  const equipos = {teams:[
    //my team
    {name: teamName, players: [
      {name: "James Trotmann", skills: generateRandomNumber(40,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(40,80,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: '', id: uuid.v4()},
      {name: nameSurname(), skills: generateRandomNumber(1,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(10,80,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: ''},
      {name: "Mery Newhouses", skills: generateRandomNumber(1,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(10,80,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: ''},
      {name: nameSurname(), skills: generateRandomNumber(1,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(10,80,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: ''},
      {name: nameSurname(), skills: generateRandomNumber(1,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(10,80,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: ''},
      {name: "Salem Saberhagen", skills: generateRandomNumber(40,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(10,80,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: ''},
      {name: "Sanna Clementsson", skills: generateRandomNumber(10,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(10,80,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: ''},
      {name: nameSurname(), skills: generateRandomNumber(1,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(10,80,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: ''},
      {name: nameSurname(), skills: generateRandomNumber(1,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(10,80,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: ''},
      {name: name, skills: generateRandomNumber(40,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(40,80,2), age: generateOneRandom(20,24), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: ''},
      {name: nameSurname(), skills: generateRandomNumber(40,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(40,80,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: ''},
      {name: nameSurname(), skills: generateRandomNumber(40,80,7), broom: [30,30,30,99], hiddenSkills: generateRandomNumber(40,80,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats:allStatsForGame(), injury: 0, nickname: ''},
      nPly(1),
      nPly(1),
      nPly(2),
      nPly(2),
      nPly(3),
      nPly(3)
    ], points: 0, tantosF: 0, tantosC: 0, id: 1, partidosGanados: 0, partidosPerdidos:0},
    {name: "Abejas de Aos", players: [
      nPly(2),nPly(1),nPly(2),nPly(2),nPly(1),nPly(2),nPly(2),
      nPly(2),nPly(1),nPly(2),nPly(2),nPly(1),nPly(2),nPly(2),
    ], points: 0, tantosF: 0, tantosC: 0, id: 2, partidosGanados: 0, partidosPerdidos:0},
    {name: "Bisontes de Banduxu", players: [
      nPly(3),nPly(3),nPly(2),nPly(3),nPly(2),nPly(3),nPly(3),
      nPly(3),nPly(3),nPly(2),nPly(3),nPly(2),nPly(3),nPly(3),
    ], points: 0, tantosF: 0, tantosC: 0, id: 3, partidosGanados: 0, partidosPerdidos:0},
    {name: "Mapaches de Masca", players: [
      nPly(2),nPly(3),nPly(3),nPly(3),nPly(3),nPly(3),nPly(2),
      nPly(2),nPly(3),nPly(3),nPly(3),nPly(3),nPly(3),nPly(2),
    ], points: 0, tantosF: 0, tantosC: 0, id: 4, partidosGanados: 0, partidosPerdidos:0},
    {name: "Pumas de Piornedo", players: [
      nPly(2),nPly(2),nPly(3),nPly(2),nPly(2),nPly(3),nPly(2),
      nPly(2),nPly(2),nPly(3),nPly(2),nPly(2),nPly(3),nPly(2),
    ], points: 0, tantosF: 0, tantosC: 0, id: 5, partidosGanados: 0, partidosPerdidos:0},
    {name: "Dragones de Duruelo", players: [
      nPly(2),nPly(2),nPly(3),nPly(1),nPly(2),nPly(3),nPly(2),
      nPly(2),nPly(2),nPly(3),nPly(1),nPly(2),nPly(3),nPly(2),
    ], points: 0, tantosF: 0, tantosC: 0, id: 6, partidosGanados: 0, partidosPerdidos:0},
    {name: "Cabras de Cortegana", players: [
      nPly(3),nPly(2),nPly(3),nPly(1),nPly(2),nPly(2),nPly(2),
      nPly(3),nPly(2),nPly(3),nPly(1),nPly(2),nPly(2),nPly(2),
    ], points: 0, tantosF: 0, tantosC: 0, id: 7, partidosGanados: 0, partidosPerdidos:0},
    {name: "Jaguars de Jerez", players: [
      nPly(2),nPly(2),nPly(2),nPly(1),nPly(1),nPly(2),nPly(2),
      nPly(2),nPly(2),nPly(2),nPly(1),nPly(1),nPly(2),nPly(2),
    ], points: 0, tantosF: 0, tantosC: 0, id: 8, partidosGanados: 0, partidosPerdidos:0},
    {name: "Toros de Trevejo", players: [
      nPly(1),nPly(2),nPly(1),nPly(1),nPly(2),nPly(1),nPly(3),
      nPly(1),nPly(2),nPly(1),nPly(1),nPly(2),nPly(1),nPly(3),
    ], points: 0, tantosF: 0, tantosC: 0, id: 9, partidosGanados: 0, partidosPerdidos:0},
    {name: "Ratones de Romeral", players: [
      nPly(1),nPly(2),nPly(1),nPly(1),nPly(2),nPly(1),nPly(2),
      nPly(1),nPly(2),nPly(1),nPly(1),nPly(2),nPly(1),nPly(2),
    ], points: 0, tantosF: 0, tantosC: 0, id: 10, partidosGanados: 0, partidosPerdidos:0},
    {name: "Renos de Redes", players: [
      nPly(1),nPly(2),nPly(1),nPly(1),nPly(2),nPly(1),nPly(2),
      nPly(1),nPly(2),nPly(1),nPly(1),nPly(2),nPly(1),nPly(2),
    ], points: 0, tantosF: 0, tantosC: 0, id: 11, partidosGanados: 0, partidosPerdidos:0},
    {name: "Osos de Ohanes", players: [
      nPly(2),nPly(2),nPly(1),nPly(3),nPly(2),nPly(1),nPly(3),
      nPly(2),nPly(2),nPly(1),nPly(3),nPly(2),nPly(1),nPly(3),
    ], points: 0, tantosF: 0, tantosC: 0, id: 12, partidosGanados: 0, partidosPerdidos:0},
    {name: "Serpientes de Sabinosa", players: [
      nPly(1),nPly(2),nPly(3),nPly(2),nPly(2),nPly(2),nPly(1),
      nPly(1),nPly(2),nPly(3),nPly(2),nPly(2),nPly(2),nPly(1),
    ], points: 0, tantosF: 0, tantosC: 0, id: 13, partidosGanados: 0, partidosPerdidos:0},
    {name: "Velociraptors de Viniegra", players: [
      nPly(1),nPly(2),nPly(1),nPly(1),nPly(2),nPly(1),nPly(1),
      nPly(1),nPly(2),nPly(1),nPly(1),nPly(2),nPly(1),nPly(1),
    ], points: 0, tantosF: 0, tantosC: 0, id: 14, partidosGanados: 0, partidosPerdidos:0},
    {name: "Fantasmas de Frias", players: [
      nPly(1),nPly(1),nPly(1),nPly(1),nPly(1),nPly(1),nPly(1),
      nPly(1),nPly(1),nPly(1),nPly(1),nPly(1),nPly(1),nPly(1),
    ], points: 0, tantosF: 0, tantosC: 0, id: 15, partidosGanados: 0, partidosPerdidos:0},
    {name: "Jabalies de Jorquera", players: [
      nPly(1),nPly(2),nPly(2),nPly(1),nPly(2),nPly(1),nPly(2),
      nPly(1),nPly(2),nPly(2),nPly(1),nPly(2),nPly(1),nPly(2),
    ], points: 0, tantosF: 0, tantosC: 0, id: 16, partidosGanados: 0, partidosPerdidos:0},
    {name: "Tiburones de Torla", players: [
      nPly(3),nPly(3),nPly(1),nPly(2),nPly(2),nPly(2),nPly(2),
      nPly(3),nPly(3),nPly(1),nPly(2),nPly(2),nPly(2),nPly(2),
    ], points: 0, tantosF: 0, tantosC: 0, id: 17, partidosGanados: 0, partidosPerdidos:0},
    {name: "Moscas de Mazaleon", players: [
      nPly(2),nPly(3),nPly(3),nPly(2),nPly(2),nPly(2),nPly(3),
      nPly(2),nPly(3),nPly(3),nPly(2),nPly(2),nPly(2),nPly(3),
    ], points: 0, tantosF: 0, tantosC: 0, id: 18, partidosGanados: 0, partidosPerdidos:0},
    {name: "Sapos de Sotillo", players: [
      nPly(2),nPly(2),nPly(2),nPly(1),nPly(1),nPly(1),nPly(1),
      nPly(2),nPly(2),nPly(2),nPly(1),nPly(1),nPly(1),nPly(1),
    ], points: 0, tantosF: 0, tantosC: 0, id: 19, partidosGanados: 0, partidosPerdidos:0},
    {name: "Estrellas de Estremera", players: [
      nPly(3),nPly(2),nPly(2),nPly(3),nPly(3),nPly(3),nPly(2),
      nPly(3),nPly(2),nPly(2),nPly(3),nPly(3),nPly(3),nPly(2),
    ], points: 0, tantosF: 0, tantosC: 0, id: 20, partidosGanados: 0, partidosPerdidos:0}
  ],
  settings: {
    difficulty: 1,
    comentarySpeed: 0,
    versionModeloDeDatos: 4,
    language: 0,
    backButtonAbled: false,
    informInjuries: true,
    darkTheme: false
  },
  profile: {
    managerName: name,
    money: 5000,
    grageas: 8,
    uuid: uuid.v4(),
    objects: {
      felixFelicis: 0,
      piedraFilosofal: 0,
      pocionCurativa: 0,
      pocionMultijugos: 0,
      hechizoConfundus: 0,
      polvoHerrero: 0
    }
  },
  others: {
    siguientePartido: 1,
    vecesTodosLosPartidosHechos: 0,
    inmatchStates: {
      felixFelicis: false,
      felixFelicisEnemy: false,
      confundus: false,
      confundusEnemy: false,
      strategy: {
        chasers: 1,
        beaters: 1,
        changes: 1,
        notUsed: 1,
        beaTacOff: 1,
        beaTacDef: 1,
        keepTac: 1,
        seekTac: 1
      },
      strategyEnemy: {
        chasers: 1,
        beaters: 1,
        changes: 1,
        notUsed: 1,
        beaTacOff: 1,
        beaTacDef: 1,
        keepTac: 1,
        seekTac: 1
      }
    },
    brooms: [
      {name: "Barredora 1",velocidad:48,maniobra:52,estabilidad:47,partidos:0},
      {name: "Cometa 140",velocidad:47,maniobra:71,estabilidad:60,partidos:0},
      {name: "Flecha de Plata",velocidad:41,maniobra:48,estabilidad:62,partidos:0}
    ],
    championships: {
      losersCup: {
        rondas: [1,3,5,7,9,11,13,15,17,21,23,25,27,29,31,33,35,37],
        gamesPerRound:9,
        currentRound:0,
        equipos: [{id:17,results:[]},{id:18,results:[]},{id:19,results:[]},{id:20,results:[]}]
      },
      spanishCup: {
        rondas: [4,6,8,12,14,16,22,24,26,32,34,36],
        gamesPerRound:3,
        currentRound:0,
        equipos: [{id:1,results:[]},{id:2,results:[]},{id:3,results:[]},{id:4,results:[]},{id:5,results:[]},{id:6,results:[]},{id:7,results:[]},{id:8,results:[]},{id:9,results:[]},{id:10,results:[]},{id:11,results:[]},{id:12,results:[]},{id:13,results:[]},{id:14,results:[]},{id:15,results:[]},{id:16,results:[]}]
      },
      europeanCup: {
        rondas: [6,8,10,12,14,17,19,21,23,25,28,30,32,34,36],
        gamesPerRound:5,
        currentRound:0,
        equipos: [{id:2,results:[]},{id:3,results:[]},{id:4,results:[]},{id:5,results:[]},{id:6,results:[]},{id:7,results:[]},{id:8,results:[]},{id:9,results:[]}]
      },
      worldCup: {
        rondas: [3,5,7,9,11,13,15,25,27,29,31,33,35,37],
        gamesPerRound:7,
        currentRound:0,
        equipos: [{id:10,results:[]},{id:11,results:[]},{id:12,results:[]},{id:13,results:[]}]
      },
      superCup: {
        rondas: [1],
        gamesPerRound:1,
        currentRound:0,
        equipos: [{id:0,results:[]},{id:0,results:[]}]
      }
    },
    trophies: []
  },
  multiplayer: {
    teams: []
  }
};
  const storeData = async (equipos) => {
    try {
      const jsonValue = JSON.stringify(equipos)
      await AsyncStorage.setItem('equipos', jsonValue)
    } catch (e) {
      console.log("error saving file")
      console.log(e)
    }
  }

  storeData(equipos);

  console.log("everything seems fine")

  return {isCorrect:true,data:equipos};
}

function nPly(calidad) {
  //crea un nuevo jugador, y le puedes pasar una calidad
  if (calidad == 3) return {name: nameSurname(), skills: generateRandomNumber(70,90,7), broom: generateRandomNumber(70,90,4), hiddenSkills: generateRandomNumber(70,90,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats: allStatsForGame(), injury: 0, nickname: ''}
  if (calidad == 2) return {name: nameSurname(), skills: generateRandomNumber(50,70,7), broom: generateRandomNumber(50,70,4), hiddenSkills: generateRandomNumber(50,70,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats: allStatsForGame(), injury: 0, nickname: ''}
  if (calidad == 1) return {name: nameSurname(), skills: generateRandomNumber(30,50,7), broom: generateRandomNumber(30,50,4), hiddenSkills: generateRandomNumber(30,50,2), age: generateOneRandom(20,27), stats: allStats(), inGameStats: allStatsForGame(), injury: 0, nickname: ''}
}

function generateRandomNumber(from, to, howMany) {
  const diferencia = to - from + 1;
  let numbers = [];
  for(let i = 0; i < howMany; i++) {
    numbers[i] = Math.floor(Math.random() * diferencia + from);
  }
  return numbers;
}

function generateOneRandom(from, to){
  const diferencia = to - from + 1;
  return Math.floor(Math.random() * diferencia + from)
}

export default NewGame